import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityActivitiesComponent } from './entity-activities.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { TooltipModule } from 'ngx-bootstrap';
import { CandidateCardIconsModule } from '../candidate-card-icons/candidate-card-icons.module';
import { SkeletonLoaderModule } from '../skeleton-loader/skeleton-loader.module';

@NgModule({
  declarations: [EntityActivitiesComponent],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule,
    TooltipModule.forRoot(),
    CandidateCardIconsModule,
    SkeletonLoaderModule
  ],
  entryComponents: [EntityActivitiesComponent],
  exports: [EntityActivitiesComponent]
})
export class EntityActivitiesModule { }
